<template>
  <registration-request-layout
    :requestId="requestId"
    :onRequestProcessed="onRequestProcessed"
    :getRegistrationRequestById="workflowService.getRenewAffiliateRequestById"
    :approveRegistrationRequest="workflowService.approveRenewAffiliateRequest"
    :denyRegistrationRequest="workflowService.denyRenewAffiliateRequest"
    :signSignatureByAdminFn="workflowService.signRenewAffiliateSignatureByAdmin"
    :markPaidByAdminFn="workflowService.markRenewAffiliatePaidByAdmin"
    :setRegistrationData="(registration) => (this.registration = registration)"
  >
    <renew-affiliate-request
      :registration="registration"
    ></renew-affiliate-request>
  </registration-request-layout>
</template>

<script lang="ts">
import Vue from "vue";
import RenewAffiliateRequest from "@/components/Portal/MyRequest/RenewAffiliateRequest.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";

export default Vue.extend({
  name: "RenewAffiliateCard",
  props: {
    requestId: { type: Number },
  },
  components: {
    RegistrationRequestLayout,
    RenewAffiliateRequest,
  },
  data: function () {
    return {
      registration: {
        workflowGuid: "",
        requestId: 0,
      } as any,
    };
  },
  computed: {
    workflowService() {
      return workflowService;
    },
  },
  methods: {
    onRequestProcessed: function (requestId: number) {
      this.$navigate({ path: `/admin/renew/affiliate` });
    },
  },
});
</script>
